import $ from "jquery";
import Headroom from "headroom.js";

var desktopMenu = function() {
  var myElement = document.querySelector(".header-desktop");
  var headroom  = new Headroom(myElement, {
    offset : 72,
  });
  headroom.init();
  $(".menu-desktop__quick-search").submit(function(event) {
    let query = $('.quick-search-query').val()
    if(query){
      window.location.href = `../search?q=${query}`;
    }
    event.preventDefault();
  });
  $('.header-desktop .search').click(function(event){
    event.preventDefault();
    $(".menu-desktop__quick-search").toggleClass('visible');
  });
  $(document).keyup(function(e) {
     if (e.key === "Escape") {
       $(".menu-desktop__quick-search").removeClass('visible');
    }
  });
  $(document).scroll(function(){
    if(!$('.quick-search-query').val()){
      $(".menu-desktop__quick-search").removeClass('visible');
    }
  })

};

export default desktopMenu;



// WEBPACK FOOTER //
// ./src/scripts/functions/desktopmenu.js